module.exports = __webpack_public_path__ + "img/elite-hospital-bg.8ab8d077.jpg";